import React, { useEffect, useState } from "react";
import {
  CSmartTable,
  CCard,
  CCardHeader,
  CCardBody,
  CTabContent,
  CTabPane,
  CBadge,
} from "@coreui/react-pro";

import * as MarketsmsService from "../../services/MarketsmsService";
import { getBadge } from "../../Utils/BaseApp";
import { ProvidersItems } from "../../models/Providers";

interface ProvidersProps { }

export const ProvidersAdministrator: React.FC<ProvidersProps> = ({ }: ProvidersProps) => {
  const [providers, setProviders] = useState<ProvidersItems[] | null>(null);

  const getProviders = async () => {

    var response = await MarketsmsService.getProviders();

    if (response) {
      if (response.status === 200) {
        setProviders(response.data.items);
      }
    }
  };

  useEffect(() => {
    getProviders();
  }, []);

  const columns = [
    {
      key: "id",
      label: "Id",
      _style: { width: "5%" },
    },
    {
      key: "name",
      label: "Nombre",
      _style: { width: "20%" },
    },
    {
      key: "type_name",
      label: "Tipo",
      _style: { width: "10%" },
    },
    {
      key: "status_name",
      label: "Estado",
      _style: { width: "10%" },
    }
  ];

  return (
    <div className="col-12">
      <CCard className="mb-4">
        <CCardHeader>
          <strong>Proveedores</strong>
        </CCardHeader>
        <CCardBody>
          <CTabContent className="rounded-bottom">
            <CTabPane
              className="p-3 active preview show"
              role="tabpanel"
              id="preview-578"
            >
              <CSmartTable
                activePage={2}
                cleaner
                clickableRows
                columns={columns}
                columnFilter
                columnSorter
                loading={providers === null ? true : false}
                items={providers ?? []}
                itemsPerPageSelect
                itemsPerPage={10}
                pagination
                scopedColumns={{
                  status_name: (provider: ProvidersItems) => (
                    <td>
                      <CBadge color={getBadge(provider.status_id)}>
                        {provider.status_name}
                      </CBadge>
                    </td>
                  )
                }}
                sorterValue={{ column: "status", state: "asc" }}
                tableFilter
                tableProps={{
                  className: "add-this-class",
                  responsive: true,
                  striped: true,
                  hover: true,
                }}
                tableBodyProps={{
                  className: "align-middle",
                }}
              />
            </CTabPane>
          </CTabContent>
        </CCardBody>
      </CCard>
    </div>
  );
};